<template>
  <div :class="cardClass">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { cn } from '@/lib/utils'

interface Props {
  class?: string
}

const props = defineProps<Props>()

const cardClass = computed(() => 
  cn(
    "tw:rounded-lg tw:border tw:bg-card tw:text-card-foreground tw:shadow-xs",
    props.class
  )
)
</script>
